// Styles for inline ReactTable elements

import FuseTheme from "../global/theme";

export const tableStyles = {
    error: {fontSize: 16, color: FuseTheme.palette.errorColor},
    warning: {color: FuseTheme.palette.errorColor},
    footer: {fontSize: 13, fontWeight: 600, textAlign: 'right'},
    hide: {display: 'none'},

    thGroupMin: {width: 220, minWidth: 220},
    thSmall: {fontSize: 11},
    thLast: {borderRight: '1px solid #bdbdbd'},

    tdMax: {width: 90, maxWidth: 90},
    tdMin: {width: 110, minWidth: 110},
    tdMinRight: {width: 110, minWidth: 110, textAlign: 'right'},
    tdMin180: {width: 180, minWidth: 180},

    btnContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginTop: 20
    },
    btn: {
        margin: '0 1em 0 0'
    },
    tableBtn: {
        // width: 86,
        minWidth: 86,
        height: 25,
        lineHeight: '25px',
        margin: 0
    },
    tableBtnMedium: {
        // width: 106,
        minWidth: 106,
        height: 25,
        lineHeight: '25px',
        margin: 0
    },
    tableBtnInline: {
        margin: '0 0 0 10px'
    },
    tableBtnStyle: {
        // width: 86,
        height: 25,
        lineHeight: '25px',
        margin: 0,
        padding: '0 2px 0 2px'
    },
    tableBtnLabel: {
        fontSize: '13px',
        lineHeight: '25px',
        padding: '0 2px 0 2px'
    },
    tableIconButton: {
        display: 'inline-block',
        width: 40,
        height: 25,
        color: '#262360',
        padding: '0 0 0 10px',
        verticalAlign: 'middle',
        cursor: 'pointer'
    },
    disabledTableIconButton: {
        display: 'inline-block',
        width: 40,
        height: 26,
        color: 'rgba(33,33,33,0.3)',
        padding: '0 0 0 10px',
        verticalAlign: 'middle',
        cursor: 'pointer',
        pointerEvents: 'none',
        opacity: '0.7'
    },
    tableIconLoader: {
        display: 'inline-block',
        width: 40,
        height: 26,
        color: '#262360',
        padding: '2px 0 0 15px',
        verticalAlign: 'middle',
        cursor: 'pointer'
    },

    left: {textAlign: 'left', textOverflow: 'initial'},
    center: {textAlign: 'center', textOverflow: 'initial'},
    right: {textAlign: 'right', textOverflow: 'initial'},

    wrapText: {wordWrap: 'break-word', textOverflow: 'initial'},
    noWrapText: {whiteSpace: 'nowrap', textOverflow: 'initial'},
    linkDefault: {
        cursor: 'pointer',
        color: FuseTheme.palette.primary3Color
    },
    flexContainerRight: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    printBtn: {color: FuseTheme.palette.primary3Color, marginLeft: 10},
    printBtnCenter: {color: FuseTheme.palette.primary3Color, margin: '20px 10px 10px 10px'},
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/styles-table.js